import { render, staticRenderFns } from "./ServiceMsg.vue?vue&type=template&id=33cb75e3&"
import script from "./ServiceMsg.vue?vue&type=script&lang=js&"
export * from "./ServiceMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports